import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/icon/element.js';
import style from './style.lit.css';
import translations from './translations.js';

/**
 * Card prefooter element used to display information on card comments and likes
 *
 * @prop commentCount - Total number of comments
 * @prop lastPersonLike - Name of the last person that liked (only in Desktop version)
 * @prop likeCount -Total number of likes
 *
 */

export default class CardPrefooter extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  /** @internal */
  static translations = translations;

  static properties = {
    commentCount: { type: Number },
    lastPersonLike: { type: String },
    likeCount: { type: Number },
  };

  /** @internal */
  get countedLikes() {
    return this.likeCount - 1;
  }

  /** @internal */
  get shouldRenderComments() {
    return this.commentCount && this.commentCount >= 0;
  }

  renderLikes() {
    return html`
      <span class="info-likes">
        <ef-icon name="thumbs-up"></ef-icon>
        <span class="count">${this.likeCount}</span>
        <span class="additional-info">
          ${this.likeCount > 0
            ? this.t('like', {
                count: this.likeCount,
                restCount: this.countedLikes,
                lastPerson: this.lastPersonLike,
              })
            : this.t('be_the_first')}
        </span>
      </span>
    `;
  }

  renderComments() {
    return html`
      <span class="info-comments">
        ${this.t('comment', { count: this.commentCount })}
      </span>
    `;
  }

  render() {
    return html`
      ${this.renderLikes()}
      ${this.shouldRenderComments ? this.renderComments() : null}
    `;
  }
}

CardPrefooter.registerTagName('xs-card-prefooter');

customElements.get('xs-card-prefooter') ||
  customElements.define('xs-card-prefooter', CardPrefooter);
